// Paylaşılan profil linkini uygulamada açmak (1.3.5 · D-649).
//
// Link uygulama kapalıyken de (açılış linki) açıkken de (olay) gelebilir.
// Profil ancak giriş yapılmış ve uygulama bir ana ekrana gelmişken açılabilir:
// giriş akışının ortasında ekran değiştirmek kullanıcıyı onboarding'den
// koparırdı. Bu yüzden link önce bekletiliyor, hazır olunca açılıyor
// (1.2.7.1 — hedef giriş boyunca korunur).
//
// Ad kimliğe sunucuda, giriş yapmış üye adına çevriliyor; hesapsız biri o
// uçla üye adlarını yoklayamıyor.
import { useEffect, useState } from 'react';
import { Linking, Platform } from 'react-native';
import { api } from '../services/api';
import { profileUsernameFromUrl } from './profileLink';

type LinkingLike = {
  getInitialURL(): Promise<string | null>;
  addEventListener(type: 'url', handler: (event: { url: string }) => void): { remove(): void };
};

export function useProfileLinkOpener(options: {
  token: string;
  myId: number;
  ready: boolean;
  openUser: (id: number) => void;
  openOwnProfile: () => void;
  onNotFound: () => void;
  resolve?: (token: string, username: string) => Promise<{ id: number }>;
  linking?: LinkingLike;
}) {
  const { token, myId, ready, openUser, openOwnProfile, onNotFound } = options;
  const resolve = options.resolve ?? api.getUserIdByUsername;
  const linking = options.linking ?? (Linking as unknown as LinkingLike);
  const [pending, setPending] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    linking.getInitialURL()
      .then((url) => {
        const username = profileUsernameFromUrl(url);
        if (!active || !username) return;
        setPending(username);
        // Web: adres çubuğundaki ?u= sayfa yenilenince profili yeniden açmasın.
        if (Platform.OS === 'web') {
          const browser = globalThis as { history?: { replaceState?: (state: null, title: string, url: string) => void } };
          browser.history?.replaceState?.(null, '', '/');
        }
      })
      .catch(() => {});
    const sub = linking.addEventListener('url', ({ url }) => {
      const username = profileUsernameFromUrl(url);
      if (username) setPending(username);
    });
    return () => { active = false; sub.remove(); };
  }, [linking]);

  useEffect(() => {
    if (!pending || !token || !myId || !ready) return;
    let active = true;
    const username = pending;
    resolve(token, username)
      .then(({ id }) => {
        if (!active) return;
        setPending(null);
        if (id === myId) openOwnProfile();
        else openUser(id);
      })
      .catch(() => {
        if (!active) return;
        setPending(null);
        onNotFound();
      });
    return () => { active = false; };
  }, [pending, token, myId, ready, resolve, openUser, openOwnProfile, onNotFound]);

  return { pending };
}
